(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quick-reorder"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.quick-reorder-item-form').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      const button = event.submitter;
      if (!(button instanceof HTMLButtonElement) || !button.classList.contains('quick-reorder__submit') || button.disabled) return;

      const row = button.closest('.quick-reorder-item-form');
      const quantityInput = row?.querySelector('input[name="quantity"]');
      const error = row?.querySelector('.quick-reorder-item__error');
      const quantity = Number(quantityInput?.value || 0);
      const variantId = Number(row?.dataset.variantId);

      if (!row || !quantityInput || !Number.isFinite(quantity) || !variantId) return;

      const minimum = Number(quantityInput.dataset.min || 1);
      const increment = Number(quantityInput.step || 1);
      if (quantity <= 0 || quantity < minimum || (quantity - minimum) % increment !== 0) {
        if (error) {
          error.textContent = `${error.dataset.minimumMessage} ${error.dataset.incrementMessage}`;
          error.hidden = false;
        }
        quantityInput.focus();
        return;
      }

      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      if (error) {
        error.hidden = true;
        error.textContent = '';
      }

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: [{ id: variantId, quantity }],
            sections: 'cart-drawer-section',
            sections_url: window.location.pathname,
          }),
        });
        const data = await response.json();

        if (!response.ok) {
          throw new Error(data?.description || data?.message || 'Unable to add item to cart.');
        }

        const drawerSectionHTML = data?.sections?.['cart-drawer-section'];
        const drawerSection = document.getElementById('shopify-section-cart-drawer-section');
        if (drawerSectionHTML && drawerSection) drawerSection.outerHTML = drawerSectionHTML;

        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();
        const cartIcon = document.querySelector('cart-icon');
        if (cartIcon && typeof cartIcon.renderCartBubble === 'function') {
          cartIcon.renderCartBubble(cart.item_count);
        }

        const cartDrawer = document.getElementById('cart-drawer');
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        } else {
          const cartTrigger = document.querySelector('[aria-controls="cart-drawer"]');
          if (cartTrigger instanceof HTMLElement) cartTrigger.click();
          else window.location.href = window.Theme?.routes?.cart_url || '/cart';
        }
      } catch (addError) {
        if (error) {
          error.textContent = addError.message;
          error.hidden = false;
        }
        console.error('[quick-reorder] Failed to add item to cart:', addError);
      } finally {
        button.disabled = row.dataset.unavailable === 'true';
        button.removeAttribute('aria-busy');
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
